<template>
  <div class="coupon-card list-warp-content">
    <div class="list-item flex align-center" :class="{ expired, used, cantUse, over }">
      <div class="list-item-money">
        <template v-if="item.type === typeMap.reduce">
          <span class="yuan">¥</span>
          <span class="price">{{ item.discounts | intPrice }}</span>
        </template>
        <template v-else>
          <span>{{ item.discounts | intDiscount }}</span>
          <span class="discount">折</span>
        </template>
      </div>
      <div class="list-item-info">
        <div class="flex space-between align-center">
          <div class="info-content">
            <div class="full-reduction">
              <span v-if="item.threshold > 0">
                满 {{ item.threshold | intPrice }} 元可用{{ item.getLimit > 1 ? `(限领${item.getLimit}张)` : '' }}
              </span>
              <span v-else>无门槛券</span>
            </div>
            <div class="date" v-if="type === 'receive'">
              {{ item.useTime }}
            </div>
            <div class="date" v-else>
              {{ item.useBeginTime | parseDate('yyyy-MM-dd') }}至{{ item.useEndTime | parseDate('yyyy-MM-dd') }}
            </div>
            <div class="apply-goods">{{ item.scope > 0 ? '指定商品可用' : '全部商品可用' }}</div>
            <div style="margin-top: 4px" v-if="item.type === typeMap.discount && item.maxDiscounts" class="apply-goods">
              优惠上限{{ item.maxDiscounts | intPrice }}元
            </div>
          </div>
          <div class="btns">
            <van-button
              class="receive-btn"
              plain
              type="primary"
              size="mini"
              :border="false"
              v-if="type === 'receive' && canReceive"
              v-reClick="() => receiveCoupon(item)"
              color="#FF4E47"
            >
              {{ item.receiveStatus === 0 ? '立即领取' : item.receiveStatus === 1 ? '继续领取' : '' }}
            </van-button>
            <van-button
              round
              type="primary"
              size="mini"
              :border="false"
              v-if="type === 'use' && showUseBtn"
              color="#FF4E47"
              @click.stop="useCoupon(item)"
              style="font-size: 12px; min-width: 68px"
            >
              去使用
            </van-button>
            <van-radio
              class="coupon-radio"
              @click.stop="radioClick(item)"
              v-if="type === 'choose'"
              :name="item.couponUserId"
            />
          </div>
        </div>
      </div>
      <div class="hasget-icon" v-if="hasReceive">
        <img :src="require('@/assets/imgs/coupon/has-receive.png')" alt="" />
      </div>
      <div class="hasget-icon" v-else-if="over">
        <img :src="require('@/assets/imgs/coupon/icon-none.png')" alt="" />
      </div>
      <div class="hasget-icon" v-else-if="expired">
        <img :src="require('@/assets/imgs/coupon/icon-expired.png')" alt="" />
      </div>
      <div class="hasget-icon" v-else-if="used">
        <img :src="require('@/assets/imgs/coupon/icon-used.png')" alt="" />
      </div>
    </div>
    <div class="type-icon" v-if="isNew && showNewIcon">
      <img v-if="expired" :src="require('@/assets/imgs/coupon/new-dark.png')" alt="" />
      <img v-else :src="require('@/assets/imgs/coupon/new.png')" alt="" />
    </div>
    <div class="type-icon type-icon-1" v-if="isOld && showNewIcon">
      <img v-if="expired" :src="require('@/assets/imgs/coupon/old_exp.png')" alt="" />
      <img v-else :src="require('@/assets/imgs/coupon/old.png')" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  filters: {
    intPrice(val) {
      if (!val) return val;
      return Number(val) / 100;
    },
    intDiscount(val) {
      if (!val) return val;
      if (val / parseInt(val) === 1) return parseInt(val);
      return val;
    }
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    type: {
      // choose: 选择， use: 立即使用， receive： 立即领取
      type: String,
      default: ''
    },
    expired: {
      // 已过期
      type: Boolean,
      default: false
    },
    used: {
      // 已使用
      type: Boolean,
      default: false
    },
    cantUse: {
      // 差多少元不能使用
      type: Boolean,
      default: false
    },
    // over: {
    //   // 已领完
    //   type: Boolean,
    //   default: false
    // },
    // hasReceive: {
    //   // 已领取
    //   type: Boolean,
    //   default: false
    // },
    showNewIcon: {
      // 是否显示新人标志
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      typeMap: {
        reduce: 0,
        discount: 1
      }
    };
  },

  computed: {
    isNew() {
      return this.item.receiveUserType == 1;
    },
    isOld() {
      return this.item.receiveUserType == 3;
    },
    canReceive() {
      if (this.type === 'receive') {
        if (this.item.changeStatus) return false
        return this.item.receiveStatus === 0 || this.item.receiveStatus === 1;
      }
      return false;
    },
    showUseBtn() {
      return !this.used && !this.expired;
    },
    hasReceive() {
      //  0: 未领取,可点击领取
      // 1: 已领取部分张数,可继续领取
      // 2: 已领取,达到领取上限,不可继续领取
      // 3: 未领取成功,已被他人领取完,不可领取
      // 4: 未领取成功,优惠券已过期
      // 5: 不符合领取条件(比如新老用户的限制)
      if (this.type === 'receive') {
        return this.item.receiveStatus === 1 || this.item.receiveStatus === 2 || this.item.receiveStatus === 5;
      }
      return false;
    },
    over() {
      if (this.type === 'receive') {
        return this.item.receiveStatus === 3;
      }
      return false;
    }
  },
  methods: {
    receiveCoupon(item) {
      this.$emit('receiveCoupon', item);
    },
    useCoupon(item) {
      this.$emit('useCoupon', item);
    },
    radioClick(item) {
      this.$emit('radioClick', item);
    }
  }
};
</script>

<style lang="less" scoped>
.list-warp-content {
  position: relative;
  overflow: hidden;
  .type-icon {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 56px;

    img {
      width: 100%;
      height: 100%;
    }
  }
  .list-item {
    height: 92px;
    background: url('../../../assets/imgs/coupon/coupon-bg.png') top left/100% 100% no-repeat;
    background-size: 100% 100%;
    margin-bottom: 12px;
    position: relative;
    &.expired,
    &.used {
      background: url('../../../assets/imgs/coupon/bg-used.png') top left/100% 100% no-repeat;
    }

    &.cantUse,
    &.over {
      background: url('../../../assets/imgs/coupon/bg-cant-use.png') top left/100% 100% no-repeat;
    }
    &.over,
    &.cantUse,
    &.used,
    &.expired {
      .list-item-money {
        > span {
          color: #bfbfbf;
        }
      }
      .list-item-info {
        > span {
          color: #bfbfbf;
        }
        .date,
        .apply-goods {
          color: #bfbfbf;
        }

        .full-reduction {
          font-size: 14px;
          > span {
            color: #bfbfbf;
          }
        }
      }
    }

    &-money {
      position: relative;
      flex: 1;
      justify-content: center;
      align-items: baseline;
      display: flex;
      > span {
        text-align: center;
        color: #ff4e47;
        font-weight: 500;
        font-size: 32px;
        line-height: 32px;
      }
      .yuan {
        font-size: 20px;
      }
      .discount {
        font-size: 16px;
      }
    }
    &-info {
      flex: 2;
      padding: 0 16px;
      position: relative;
      .date,
      .apply-goods {
        color: #595959;
        font-size: 10px;
      }
      .date {
        margin: 8px 0 4px 0;
      }
      .full-reduction {
        display: flex;
        align-items: center;
        > span {
          color: #ff4e47;
          font-weight: 500;
          padding-right: 4px;
        }
        .repeat-item {
          height: 14px;
        }
      }
      .btns {
        .receive-btn {
          position: relative;
          z-index: 2;
          background: transparent;
          min-width: 56px;
          font-weight: 500;
          padding: 0;
        }
        .coupon-radio {
          /deep/ .van-radio__icon {
            border-radius: 50%;
            background-color: #ffffff;
            .van-icon {
              line-height: 1.4;
            }
          }
        }
      }
    }
    .hasget-icon {
      position: absolute;
      bottom: 0;
      right: 0;
      height: 60px;
      width: 60px;
      z-index: 1;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .flex {
    display: flex;
    width: 100%;
    &.space-between {
      justify-content: space-between;
    }
    &.align-center {
      align-items: center;
    }
    .flex-basic {
      width: 60px;
      text-align: right;
    }
  }
}
</style>
